import { getContext } from "recompose";

import { string } from "prop-types";

export default getContext({
  responsiveSize: string,
});
